var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "100%",
    height: "100%",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M449.446,0c34.525,0 62.554,28.03 62.554,62.554v386.892c0,34.524-28.03,62.554-62.554,62.554h-106.468v-192.915h66.6l12.672-82.621h-79.272v-53.617c0-22.603 11.073-44.636 46.58-44.636h36.042v-70.34s-32.71-5.582-63.982-5.582c-65.288,0-107.96,39.569-107.96,111.204v62.971h-72.573v82.621h72.573v192.915h-191.104c-34.524,0-62.554-28.03-62.554-62.554v-386.892C0,28.03,28.029,0,62.554,0h386.892Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.ce5bec3d817e655f0c469399723236a6.svg";
export { ForwardRef as ReactComponent };